<template>
  <div>
    <div style="height:120px;"></div>
    <div style="background:#f5f5f5; border-top: 1px solid #c9c9c9; box-shadow: 0 -1px 5px rgb(0 0 0 / 10%); height: 100px; width: 100%; display: flex; position: fixed; justify-content: space-around; flex-direction: column; align-items: center; bottom: 0;z-index: 99">
      <div style="display: flex;flex-direction: row;align-items: center;width: 100%;justify-content: space-evenly;padding: 0 50px;box-sizing: border-box">
        <div style="display: flex;flex-direction:column;width: 50%;height: 60px;margin-top: 10px;font-size: 12px;">
          <div style="display: flex;flex-direction: row;width:100%;height: 40px;line-height: 30px;">
            <div style="display:flex;flex-direction:row;font-size: 14px;text-align:right;font-weight: bold;">客服邮箱：{{configdata.maile}}</div>
           <div style="display:flex;flex-direction:row;width:5%;"></div>
<!--            <div style="display:flex;flex-direction:row;font-size: 14px;text-align: left;cursor: pointer">工作日：9:00-18:00</div>-->

          </div>
          <div style="margin-top: 10px">Copyright © {{configdata.companytitle}} ALL Rights Reserved 版权所有</div>
        </div>

        <div style="width: 50%;display: flex;flex-direction: column;height: 60px;font-size: 14px;margin-top: 10px;">
          <div style="display: flex;justify-content: flex-end;height: 40px;line-height: 30px;width: 100%">
            <span style="font-family: Source Han Sans CN;font-weight: bold;">服务热线:0531-87903818
              <i style="font-style: normal;font-weight: normal;color: #000;margin-left: 10px;">(工作日 9:00 ~ 18:00) </i>
            </span>
          </div>
          <div style="display: flex;justify-content: flex-end;height: 30px;line-height: 30px;width: 100%;margin-top: 10px">
            <div style="display:flex;justify-content: flex-end;font-size: 12px;">
              <div style="margin-right: 10px">
                <a target="_blank" style="color:#000" :href="'https://beian.miit.gov.cn/#/Integrated/index'"> 工信部备案号：{{configdata.sitebeian}} </a>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import policeimg from '@/assets/images/police.png'
import {conf_list} from "@/api/manage";

export default {
  name: 'footers',
  data() {
    return {
      policeimg: policeimg,
      configdata:{}
    }
  },
  created() {
    var configdata =  JSON.parse(localStorage.getItem('configdata'))
    this.configdata = configdata
  },
  methods:{
    gokefu(){
      window.open(this.configdata.serviceurl,'_blank')
    },
  }

}
</script>
<style scoped>
.icon {
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}
.footericon{
  font-size: 40px;margin-left:10px;margin-right: 5px
}
.footertxt{
  font-family: 微软雅黑,黑体;font-weight: bold;font-size: 18px
}
</style>

